import React from 'react';
import { FormField, SearchField } from '@/components/custom/erp';
import { departmentSearchColumns } from '../../cols-definition';
import { Label } from '@/components/ui/label';
import { BoPhan } from '@/types/schemas';
import { QUERY_KEYS } from '@/constants';
import { FormMode } from '@/types/form';

interface DepartmentFormProps {
  mode: FormMode;
  boPhan: BoPhan | null;
  setBoPhan: (boPhan: BoPhan) => void;
}

export default function DepartmentForm({ mode, boPhan, setBoPhan }: DepartmentFormProps) {
  const isDisabled = mode === 'view';
  const rowClassName = 'flex min-w-0 flex-col sm:flex-row sm:items-center';
  const labelClassName = 'mb-2 shrink-0 sm:mb-0 sm:w-40 sm:min-w-40';
  const fieldWrapClassName = 'min-w-0 flex-1';
  const fieldClassName = 'w-full max-w-[360px]';

  return (
    <div className='max-h-[calc(100vh-150px)] min-w-0 max-w-full overflow-y-auto overflow-x-hidden'>
      <div className='p-4'>
        <div className='flex flex-col gap-y-4'>
          <div className='space-y-4'>
            <div className={rowClassName}>
              <Label className={labelClassName}>Mã bộ phận</Label>
              <div className={fieldWrapClassName}>
                <FormField type='text' name='ma_bp' className={fieldClassName} disabled={isDisabled} />
              </div>
            </div>

            <div className={rowClassName}>
              <Label className={labelClassName}>Tên bộ phận</Label>
              <div className={fieldWrapClassName}>
                <FormField type='text' name='ten_bp' className={fieldClassName} disabled={isDisabled} />
              </div>
            </div>

            <div className={rowClassName}>
              <Label className={labelClassName}>Tên khác</Label>
              <div className={fieldWrapClassName}>
                <FormField type='text' name='ten_bp2' className={fieldClassName} disabled={isDisabled} />
              </div>
            </div>

            <div className={rowClassName}>
              <Label className={labelClassName}>Mã bộ phận phí</Label>
              <div className={fieldWrapClassName}>
                <SearchField<BoPhan>
                  type='text'
                  displayRelatedField='ten_bp'
                  columnDisplay='ma_bp'
                  dialogTitle='Danh mục bộ phận'
                  searchColumns={departmentSearchColumns}
                  searchEndpoint={`/${QUERY_KEYS.BO_PHAN}`}
                  relatedFieldValue={boPhan?.ten_bp || ''}
                  value={boPhan?.ma_bp || ''}
                  onRowSelection={setBoPhan}
                  disabled={isDisabled}
                  className={fieldClassName}
                />
              </div>
            </div>

            <div className={rowClassName}>
              <Label className={labelClassName}>Ghi chú</Label>
              <div className={fieldWrapClassName}>
                <FormField type='text' name='ghi_chu' className='w-full max-w-[480px]' disabled={isDisabled} />
              </div>
            </div>

            <div className={rowClassName}>
              <Label htmlFor='trang_thai' className={labelClassName}>
                Trạng thái
              </Label>
              <div className={fieldWrapClassName}>
                <FormField
                  id='trang_thai'
                  type='select'
                  name='status'
                  className={fieldClassName}
                  defaultValue='1'
                  disabled={isDisabled}
                  options={[
                    { label: '1. Còn sử dụng', value: '1' },
                    { label: '0. Không sử dụng', value: '0' }
                  ]}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
